import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OutrasReceitas } from 'src/app/admihair/api/dto/outras-receitas';
import { OutrasReceitasService } from 'src/app/admihair/service/outras-receitas.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { CompetenciaDTO } from 'src/app/admihair/api/dto/competencia-dto';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-outras-receitas-listar',
  templateUrl: './outras-receitas-listar.component.html',
  styleUrls: ['./outras-receitas-listar.component.scss']
})
export class OutrasReceitasListarComponent extends AdmihairBaseComponent implements OnInit {

  empresaSelecionada?: Empresa;
  listaOutrasReceitas: OutrasReceitas[] = [];
  loading: boolean = false;
  dataInicio: Date = new Date();
  dataFim: Date = new Date();

  listaCompetenciasReceitas: SelectItem[] = [];
  filtroCompetenciaSelecionada?: CompetenciaDTO;

  constructor(private outrasReceitasService: OutrasReceitasService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
    super(erroService, utilStorageService)
  }

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.loading = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    this.dataFim.setDate(this.dataFim.getDate() + 15);
    if (this.permissaoListar) {
      this.buscarCompetencias();
    }

  }

  buscarCompetencias() {
    this.outrasReceitasService.buscarCompetenciasPorEmpresa(this.empresaSelecionada?.id).subscribe({
      next: (data: CompetenciaDTO[]) => {
        this.listaCompetenciasReceitas = data.map(competencia => (
          { label: competencia.descricao, value: competencia }));
        this.filtroCompetenciaSelecionada = data[0];
        this.listarOutrasReceitas();
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  listarOutrasReceitas() {
    this.outrasReceitasService.listarPorEmpresaECompetencia(
      this.empresaSelecionada?.id,
      this.filtroCompetenciaSelecionada?.mes,
      this.filtroCompetenciaSelecionada?.ano
    ).subscribe({
      next: (data: OutrasReceitas[]) => {
        this.loading = false;
        this.listaOutrasReceitas = data;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  recarregarDados() {
    this.loading = true;
    this.listarOutrasReceitas();
  }

  excluirOutraReceita(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.outrasReceitasService.excluir(id).subscribe({
          next: () => {
            this.loading = true;
            this.exibirMensagemSucesso();
            this.listarOutrasReceitas();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
            this.listarOutrasReceitas();
          }
        });
      }
    });
  }

  editarOutraReceita(id: number) {
    this._router.navigate(["/apps/outras-receitas/editar/" + id], { relativeTo: this._activatedRoute })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_OUTRAS_RECEITAS');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_OUTRAS_RECEITAS');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_OUTRAS_RECEITAS');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_OUTRAS_RECEITAS');
  }

}
